import { useLocalSearchParams } from 'expo-router';
import WalletProvisioningSuccessScreen from 'features/cardManagement/screens/WalletProvisioningSuccessScreen/WalletProvisioningSuccessScreen';
import React from 'react';

type AddToWalletSuccessParams = {
  category: string;
  subCategory: string;
  isBelieveDay0Flow?: string;
  believeAccountId?: string;
};

export default function AddToWalletSuccess() {
  const { category, subCategory, isBelieveDay0Flow, believeAccountId } =
    useLocalSearchParams<AddToWalletSuccessParams>();
  return (
    <WalletProvisioningSuccessScreen
      analyticsCategory={category}
      analyticsSubcategory={subCategory}
      isBelieveDay0Flow={isBelieveDay0Flow}
      believeAccountId={believeAccountId}
    />
  );
}
